import { Portal } from 'components/Portal'

export const Dialog = ({ attrs: { open } }) => {
  const closeDialog = () => {
    open(false)
    m.redraw()
  }

  open.map(val => {
    if (val === false) {
      document.removeEventListener('backbutton', closeDialog)
    }
  })
  return {
    oncreate ({ dom, attrs: { open } }) {
      document.addEventListener('keyup', e => {
        if (e.keyCode === 27) {
          open(false)
        }
      })
      document.addEventListener('backbutton', closeDialog)
    },
    view ({ attrs: { open, classes = [] }, children }) {
      return m(Portal, {
        onbeforeremove (dom) {
          dom.classList.add('dialogFadeOut')
          dom.children[0].classList.add('slideOutDown')
          m.redraw()
          return new Promise(resolve => {
            dom.addEventListener('animationend', resolve)
          })
        }
      }, [
        m('.py-8.inset-0.fixed.w-screen.h-screen.z-50.dialogFadeIn.overflow-auto.flex.justify-center.items-center', {
          onclick () {
            open(!open())
          }
        }, [
          m('.my-auto.dialog.flex.justify-center.items-center.slideInUp.w-11/12', {
            onclick (e) { e.stopPropagation() },
            class: classes.join(' ')
          }, children)
        ])
      ])
    }
  }
}
